import { render, staticRenderFns } from "./pilgrimsTable.vue?vue&type=template&id=16200907&"
import script from "./pilgrimsTable.vue?vue&type=script&lang=js&"
export * from "./pilgrimsTable.vue?vue&type=script&lang=js&"
import style0 from "./pilgrimsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports